import React from "react";

const ViewProductMap = ({ center }) => {
  if (!center.lat) return <></>;

  return (
    <div style={{ height: "300px", width: "100%" }}>
      {/* <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyAdfGncz6kXwl7QEi1ZaKDeM3sQf-B_848" }}
        options={{ mapTypeId: "hybrid" }}
        defaultCenter={center}
        defaultZoom={3}
        yesIWantToUseGoogleMapApiInternals //this is important!
        onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
      ></GoogleMapReact> */}
    </div>
  );
};

export default ViewProductMap;
